import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';

const appConfig = globalContext.require('component/config/index');

export function getFilterConfig({
  schema,
  i18n,
  featureName,
  preferenceStoreFactory,
  preferenceService,
  sessionStore,
}) {
  return getCommonFilterConfig({
    entitySchema: schema,
    preferenceService,
    featureName,
    i18n,
    sessionStore,
    preferenceStoreFactory: preferenceStoreFactory.getFilters,
    globalConfig: appConfig,
    enableCampaignWaterfall: false,
    editor: {},
  });
}
